import React, { useState, useEffect, MouseEvent } from 'react';
import {
    Button,
    Checkbox,
    FormControlLabel,
    Popover,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import './AddFilter.scss';
import { useTranslation } from 'react-i18next';
import { Option, options } from '../';
import { capitalizeFirstLetter } from '../../../services/stringHelperService';
interface AddFilterProps {
    selectedFilters: Record<Option, boolean>,
    onChange: (_params: Record<Option, boolean>) => void;
}

const AddFilter = ({ selectedFilters, onChange }: AddFilterProps) => {
    const { t: translator } = useTranslation();
    const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [checked, setChecked] = useState<Record<Option, boolean>>(selectedFilters);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleCheckbox = (option: Option) => {
        setChecked((prev) => ({ ...prev, [option]: !prev[option] }));
    };

    const handleOptionsReset = () => {
        setChecked(Object.fromEntries(options.map(option => [option, false])) as Record<Option, boolean>);
    };

    const open = Boolean(anchorEl);

    useEffect(() => {
        // it is important to skip the first render, because it will initialize the selected filters incorrectly
        if (!isFirstRender) {
            onChange(checked);
        } {
            setIsFirstRender(false);
        }
    }, [checked]);

    useEffect(() => {
        if (selectedFilters) {
            setChecked(selectedFilters);
        }
    }, [selectedFilters]);

    return (
        <div>
            <Button
                variant="contained"
                onClick={handleClick}
                endIcon={<AddIcon />}
                className="add-btn no-shadow"
            >
                {translator('MODAL_CREATE_SEARCH_FILTER_ADD_FILTER_BUTTON')}
            </Button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{ className: 'popover-content' }}
            >
                <div className="checkbox-list">
                    {options.map((option) => (
                        <div
                            className="checkbox-row"
                            key={option}
                            onClick={(e) => {
                                if (!(e.target as HTMLElement).closest('label')) {
                                    toggleCheckbox(option);
                                }
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!!checked[option]}
                                        onChange={() => toggleCheckbox(option)}
                                        color="primary"
                                    />
                                }
                                label={capitalizeFirstLetter(option)}
                            />
                        </div>
                    ))}
                </div>

                <Button
                    variant="contained"
                    className="footer-button"
                    onClick={handleOptionsReset}
                    disabled={Object.values(checked).every((v) => !v)}
                >
                    {translator('MODAL_CREATE_SEARCH_FILTER_CLEAR_SELECTION_BUTTON')}
                </Button>
            </Popover>
        </div>
    );
};

export default AddFilter;
